export const PRETTY_DATE_FORMAT = 'M/dd/yyyy';

// A bad day within this many days counts as imminent.
export const BAD_DAY_COUNT = 4;

// Urgency buckets, worst-first. `problems` are keyed by the first three; suppressed
// rotations are their own muted bucket.
export const Urgency = {
  TODAY: 'today',
  IMMINENT: 'imminent',
  OK: 'ok',
  SUPPRESSED: 'suppressed'
} as const;
export type UrgencyType = (typeof Urgency)[keyof typeof Urgency];

// Drives the `status-*` (dot color) and `when-*` (row tint) classes in the SCSS; the
// values must match those class suffixes exactly, so keep it a closed union.
export const RotationStatus = {
  RED: 'red',
  YELLOW: 'yellow',
  NEUTRAL: 'neutral',
  MUTED: 'muted'
} as const;
export type RotationStatusType = (typeof RotationStatus)[keyof typeof RotationStatus];

export const URGENCY_META: Record<UrgencyType, { label: string; status: RotationStatusType }> = {
  [Urgency.TODAY]: { label: 'Today', status: RotationStatus.RED },
  [Urgency.IMMINENT]: { label: 'Soon · ≤4 days', status: RotationStatus.YELLOW },
  [Urgency.OK]: { label: 'Upcoming', status: RotationStatus.NEUTRAL },
  [Urgency.SUPPRESSED]: { label: 'Suppressed', status: RotationStatus.MUTED }
};
